const searchForm = document.querySelector('.js-search-form');
const semesterDropdown = searchForm.querySelector('.js-search-semester');
const keywordInput = searchForm.querySelector('.js-search-keyword');
const applyFilterButton = searchForm.querySelector('.js-apply-filter');
const loadMoreButton = document.querySelector('.js-load-more');
const searchResultContainer = document.querySelector('.js-article-results');

const initialSemester = searchForm.dataset.initialSemester;
const initialYear = searchForm.dataset.initialYear;
const pageSize = parseInt(searchForm.dataset.pageSize || '6', 10);

const screenIsTouchable = !!('ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints);

const pagination = {
    currentPage: 1,
    pageSize,
    initialSemester,
    initialYear,
}

const syncInitialSemesterSelection = () => {
    if (!pagination.initialSemester || !pagination.initialYear) {
        return;
    }

    const expectedValue = `${pagination.initialSemester}-${pagination.initialYear}`;
    const optionIndex = Array.from(semesterDropdown.options).findIndex(option => option.value === expectedValue);

    if (optionIndex >= 0) {
        semesterDropdown.selectedIndex = optionIndex;
    }
};

syncInitialSemesterSelection();

const doSearch = async () => {
    const selectedSemester = semesterDropdown.options[semesterDropdown.selectedIndex].value;
    const splittedSelectedSemester = selectedSemester.split('-');
    const semester = parseInt(splittedSelectedSemester[0]);
    const year = parseInt(splittedSelectedSemester[1]);

    const keyword = keywordInput.value;
    // get current base url
    const searchApiUrl = window.location.origin + '/umbraco/surface/articles/findarticles';
    const urlParams = new URLSearchParams();
    urlParams.append('semester', semester);
    urlParams.append('year', year);
    urlParams.append('keyword', keyword);
    urlParams.append('page', pagination.currentPage);
    urlParams.append('pageSize', pagination.pageSize);

    // fetch the search results
    const response = await fetch(`${searchApiUrl}?${urlParams.toString()}`, { method: 'GET' });
    if (!response.ok) {
        throw new Error('Network response was not ok');
    }

    const result = await response.text();

    renderSearchResult(result.trim());
}

const renderSearchResult = (html) => {
    if (html === "" && pagination.currentPage === 1) {
        searchResultContainer.innerHTML = '<h2>No articles found</h2>';
        loadMoreButton.style.display = 'none';
        return;
    }

    if (html === "") {
        loadMoreButton.style.display = 'none';
        return;
    }

    if (pagination.currentPage === 1) {
        searchResultContainer.innerHTML = html;
    } else {
        searchResultContainer.innerHTML += html;
    }

    const tempWrapper = document.createElement('div');
    tempWrapper.innerHTML = html;

    const returnedItemsCount = tempWrapper.querySelectorAll('.article-tile').length;

    loadMoreButton.style.display =
        returnedItemsCount === pagination.pageSize ? 'inline-flex' : 'none';
};

semesterDropdown.addEventListener('change', (event) => {
    event.preventDefault();
    pagination.currentPage = 1;
    doSearch();
});


if (screenIsTouchable) {
    keywordInput.addEventListener('input', (event) => {
        if (event.target.value.length > 3) {
            pagination.currentPage = 1;
            doSearch();
        }
    });
} else {
    keywordInput.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
            pagination.currentPage = 1;
            doSearch();
        }
    });
}

applyFilterButton.addEventListener('click', () => {
    pagination.currentPage = 1;
    doSearch();
})

loadMoreButton.addEventListener('click', () => {
    pagination.currentPage++;
    doSearch();
});

document.addEventListener('DOMContentLoaded', () => {
    const initialItemCount = document.querySelectorAll('.article-tile').length;

    if (pagination.currentPage === 1 && initialItemCount < pagination.pageSize) {
        loadMoreButton.style.display = 'none';
    } else if (initialItemCount < pagination.pageSize * pagination.currentPage) {
        loadMoreButton.style.display = 'none';
    }
});
